import { render, staticRenderFns } from "./OperaModuleDataWindow.vue?vue&type=template&id=68212f0e&"
import script from "./OperaModuleDataWindow.vue?vue&type=script&lang=js&"
export * from "./OperaModuleDataWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports